import { useDispatch, useSelector } from 'react-redux';
import { EReportsSortDirection, OffersReportFiltersInput, OffersReportSortInput } from '__generated__/graphql';
import { updateFilter, updateSort, resetReportFilters } from '../../../../store/reportFiltersSlice';
import type { RootState } from '../../../../store';

export type THandleFilterChange = (field: keyof OffersReportFiltersInput, value: any) => void;
export type THandleSortChange = (field: keyof OffersReportSortInput, direction?: EReportsSortDirection) => void;

export const useReportFilters = () => useSelector((state: RootState) => state.reportFilters.filters);
export const useReportSort = () => useSelector((state: RootState) => state.reportFilters.sort);

/**
 * Hook for managing report filter controls (filter changes, sorting, reset).
 * Returns handlers for updating filters and sort state via Redux dispatch.
 */
export function useReportFilterControls() {
  const dispatch = useDispatch();

  const handleFilterChange = (field: keyof OffersReportFiltersInput, value: any) => {
    dispatch(updateFilter({ field, value }));
  };

  const handleSortChange = (field: keyof OffersReportSortInput, direction?: EReportsSortDirection) => {
    dispatch(updateSort({ field, direction }));
  };

  const handleReset = () => {
    dispatch(resetReportFilters());
  };

  return { handleFilterChange, handleSortChange, handleReset };
}